module.exports = __webpack_public_path__ + "img/hood_height.4a561601.png";